export const siteConfig = {
  name: "Ring.io",
  description: "",
  mainNav: [
    {
      title: "Home",
      href: "/",
    },
  ],
}

export type SiteConfig = typeof siteConfig
